import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageHeader } from 'ui/shared/pageHeader';

export const ErrorPage = () => {
    const { t } = useTranslation();
    return (
        <div id="error-page">
            <PageHeader title={ t('ERROR.PAGE_NOT_FOUND') }/>
            <div id="page-content" className="page">
                <p>
                    { t('ERROR.PAGE_NOT_FOUND_DESC') }
                </p>
            </div>
        </div>
    );
};
